import { AsyncPipe, ViewportScroller } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { Title } from '@angular/platform-browser'
import { ActivatedRoute, RouterLink } from '@angular/router'
import { QuillViewComponent } from 'ngx-quill'
import { catchError, map, of, startWith, switchMap } from 'rxjs'
import { VenueService } from '../../../services/venue.service'
import { defaultBookingPolicy } from './default-booking-policy'
import { richTextPlainText } from '../../../utilities/rich-text'

@Component({
    selector: 'app-venue-booking-policy',
    standalone: true,
    imports: [AsyncPipe, QuillViewComponent, RouterLink],
    templateUrl: './venue-booking-policy.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VenueBookingPolicyComponent {
    private readonly route = inject(ActivatedRoute)
    private readonly venueService = inject(VenueService)
    private readonly titleService = inject(Title)
    private readonly viewportScroller = inject(ViewportScroller)

    protected readonly defaultBookingPolicy = defaultBookingPolicy
    protected readonly state$ = this.route.paramMap.pipe(
        switchMap(params => {
            const venueSlug = params.get('venueSlug') ?? ''
            return this.venueService.getWithSlug(venueSlug).pipe(
                map(venue => {
                    this.titleService.setTitle(venue.businessDisplayName ?? 'Terms and Conditions')
                    return {
                        venue,
                        terms: richTextPlainText(venue.bookingPolicy) ? venue.bookingPolicy : null,
                        refunds: richTextPlainText(venue.depositRefundPolicy)
                            ? venue.depositRefundPolicy
                            : venue.paymentsAccount ? this.defaultBookingPolicy : null,
                        privacy: richTextPlainText(venue.privacyPolicy) ? venue.privacyPolicy : null,
                        landingPagePath: `/discover/${encodeURIComponent(venueSlug)}`,
                        loading: false,
                    }
                }),
                catchError(() => of({ venue: null, terms: null, refunds: null, privacy: null, landingPagePath: null, loading: false })),
                startWith({ venue: null, terms: null, refunds: null, privacy: null, landingPagePath: null, loading: true })
            )
        })
    )

    protected scrollToRequestedPolicy(): void {
        const fragment = this.route.snapshot.fragment
        if (fragment) {
            this.viewportScroller.scrollToAnchor(fragment)
        }
    }
}
